import React, { useState, useEffect } from 'react';
import { variables } from "../../utility/variables";
import { Input, Alert } from 'reactstrap';
import { Icons } from "../../utility/icons";
import { useMsal } from '@azure/msal-react';
import * as Msal from '@azure/msal-browser';
import { msalConfig } from '../../utility/authConfig';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
//import jwt_decode from 'jwt-decode';

const loginRequest = {
    scopes: ["User.Read"], // Request the custom API scope
};

const User = () => {
    const [users, setUsers] = useState([]);
    const [UserRoles, setUserRoles] = useState([]);
    const [modalTitle, setModalTitle] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [UserName, setUserName] = useState("");
    const [UserEmail, setUserEmail] = useState("");
    const [FullName, setFullName] = useState("");
    const [IsActive, setIsActive] = useState(false);
    const [UserTitle, setUserTitle] = useState("");
    const [UserId, setUserId] = useState(0);
    const [UserIdFilter, setUserIdFilter] = useState("");
    const [UserNameFilter, setUserNameFilter] = useState("");
    const [usersWithoutFilter, setUsersWithoutFilter] = useState([]);
    const [ShowWarning, setShowWarning] = useState(false);
    const [Warning, setWarning] = useState("");
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [filterQuery, setFilterQuery] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState("");
    const [showInviteButton, setShowInviteButton] = useState(true);
    const [RegistrationStatus, setRegistrationStatus] = useState('Yes');
    const [GlobalVendorId, setGlobalVendorId] = useState();
    const [CurrentUserRoles, setCurrentUserRoles] = useState();
    const [CurrentUserEmail, setCurrentUserEmail] = useState();
    const [AccessToken, setAccessToken] = useState([]);
    
    const [Vendors, setVendors] = useState([]);

    const { instance } = useMsal();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const [globalVendors, setglobalVendors] = useState('');
    
    const [selectedOption, setSelectedOption] = useState(null);

    const [vendorName, setvendorName] = useState('');
    const [address, setaddress] = useState('');
    const [eiN_Encrypted, seteiN_Encrypted] = useState('');
    const [globalVendorID, setglobalVendorID] = useState('');
    const [primaryContactEmail, setprimaryContactEmail] = useState('');
    const [primaryContactName, setprimaryContactName] = useState('');
    const [primaryContactPhone, setprimaryContactPhone] = useState('');
    const [secondaryContactEmail, setsecondaryContactEmail] = useState('');
    const [secondaryContactName, setsecondaryContactName] = useState('');
    const [secondaryContactPhone, setsecondaryContactPhone] = useState('');

    // Filter roles based on the search term
    const filteredVendors = Vendors.filter((ven) =>
        ven.vendorName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        refreshList();
    }, []);

    function isTokenExpired(token) {
        if (!token) return true; // If no token, consider it expired
     
        try {
            const payload = JSON.parse(atob(token.split(".")[1])); // Decode payload
            const _date = new Date(payload.exp * 1000);
            return Date.now() >= _date; // Compare expiration time
        } catch (error) {
            return true; // If token is invalid, treat as expired
        }
    }

    const refreshList = async () => {

        await fetch(variables.API_URL + 'User', {
            method: "GET",
            mode: "cors",
            credentials: "include" 
        })
        .then((response) =>{
            if( response.ok){
                return response.json(); // parse JSON only if status is 2xx
            }
            else if (response.status === 401) {
                // Handle unauthorized
                console.log('User.js: Unauthorized or session expired: Redirect to login');
                alert('Unauthorized or session expired: Redirect to login');
                navigate('/signin');
            }
        })
            .then(data => {
                console.log("refreshList User get data", data);
                setUsers(data);
                setUsersWithoutFilter(data);
            });

        await fetch(variables.API_URL + 'User/getUserRoles', {
            method: "GET",
            mode: "cors",
            credentials: "include" 
        })
            .then(response => response.json())
            .then(data => {
                console.log("getUserRoles: ", data );
                setUserRoles(data);
            });
        await fetch(variables.API_URL + 'User/validateuser', {
            method: "GET",
            mode: "cors",
            credentials: "include" 
        })
            .then(response => response.json())
            .then(data => {
                //alert(data);//setUserRoles(data);
                setGlobalVendorId(data[0].GlobalVendorID);
                setCurrentUserRoles(data[0].RoleID);
                setCurrentUserEmail(data[0].UserEmail);
            });

        await fetch(variables.API_URL + 'Vendor/GetGlobalVendorList', {
                    method: "GET",
                    mode: "cors",
                    credentials: "include", // important to send/set cookies
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data) {
                            console.log("GetGlobalVendorList data: ", data );
                            setglobalVendors(data);
                            if(!selectedOption) {
                                setvendorName(data[0].vendorName);
                                seteiN_Encrypted(data[0].eiN_Encrypted);
                                setSelectedOption( { 
                                    value: data[0].globalVendorID,
                                    label: data[0].vendorName + " ( EIN: " + (data[0].eiN_Encrypted==null?"N/A":data[0].eiN_Encrypted)  +")" });
                            }
                        }
                    });            
    };

    const FilterFn = () => {
        const filteredData = usersWithoutFilter.filter(el =>
            el.UserId.toString().toLowerCase().includes(UserIdFilter.toString().trim().toLowerCase()) &&
            el.UserName.toString().toLowerCase().includes(UserNameFilter.toString().trim().toLowerCase())
        );

        setUsers(filteredData);
    };

    const sortResult = (prop, asc) => {
        const sortedData = usersWithoutFilter.sort((a, b) => {
            if (asc) {
                return (a[prop] > b[prop]) ? 1 : (a[prop] < b[prop]) ? -1 : 0;
            } else {
                return (b[prop] > a[prop]) ? 1 : (b[prop] < a[prop]) ? -1 : 0;
            }
        });

        setUsers(sortedData);
    };

    const changeUserIdFilter = (e) => {
        setUserIdFilter(e.target.value);
        FilterFn();
    };

    const changeUserNameFilter = (e) => {
        setUserNameFilter(e.target.value);
        FilterFn();
    };

    // Regex to allow A-Z, a-z, 0-9, ., -, _, and @
    const regex1 = /^[A-Za-z0-9._\-@]*$/;
    // Regex for the second input: A-Z, a-z, 0-9, ., -, _
    const regex2 = /^[A-Za-z0-9.\-_ ]*$/;

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "UserName") { setUserName(value); }
        if (name === "UserEmail") { setUserEmail(value); }
        if (name === "FullName") { setFullName(value); }
        if (name === "UserTitle") { setUserTitle(value); }
        if (name === "IsActive") { setIsActive(value); }
        // Add other fields as needed
    };

    const loginAndGetToken = async () => {
        const msalInstance = new Msal.PublicClientApplication(msalConfig);
        await msalInstance.initialize();
        try {
            msalInstance.handleRedirectPromise().then((tokenResponse) => {
                if (!tokenResponse) {
                    const accounts = msalInstance.getAllAccounts();
                    if (accounts.length === 0) {
                        msalInstance.loginRedirect();
                    }
                }
            }).catch((err) => {
                console.error(err);
            });

            const tokenResponse = await msalInstance.acquireTokenSilent(loginRequest);
            return tokenResponse.accessToken;
        } catch (error) {
            console.error("Silent token acquisition failed, prompting login:", error);
            const tokenResponse = await msalInstance.acquireTokenPopup(loginRequest);
            return tokenResponse.accessToken;
        }
    };

    const verifyUser = async (UserEmail) => {
        const token = await loginAndGetToken();

        const graphEndpoint = `https://graph.microsoft.com/v1.0/users?$filter=mail eq '${UserEmail}'`;
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${token}`);

        try {
            const response = await fetch(graphEndpoint, { headers });
            if (!response.ok) {
                throw new Error(`Graph API error: ${response.status}`);
            }

            const users = await response.json();
            if (users.value.length > 0) {
                setUserEmail(users.value[0].mail);
                setFullName(users.value[0].displayName);
                setUserTitle(users.value[0].jobTitle);
                var _existedUser = usersWithoutFilter.find(ur => ur.vendorEmail === UserEmail);
                if ( _existedUser ) {
                    setUserTitle(_existedUser.title);
                }
                setShowWarning(false);
                setWarning("");
                setShowInviteButton(false);
            } else {
                setUserEmail(UserEmail);
                setFullName("");
                setUserTitle("");
                setShowWarning(true);
                setWarning("User does not exist.");
                setShowInviteButton(true);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const handleSelectChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        console.log('Selected Option:', selectedOption);

        var _selectedGV = globalVendors.find(gv => gv.globalVendorID === selectedOption.value);

        if (_selectedGV) {
            //setContactInfo(data);
            setvendorName(_selectedGV.vendorName);
            setaddress(_selectedGV.address ?? '');
            seteiN_Encrypted(_selectedGV.eiN_Encrypted ?? '');
            setglobalVendorID(_selectedGV.globalVendorID ?? '');
            setprimaryContactEmail(_selectedGV.primaryContactEmail ?? '');
            setprimaryContactName(_selectedGV.primaryContactName ?? '');
            setprimaryContactPhone(_selectedGV.primaryContactPhone ?? '');
            setsecondaryContactEmail(_selectedGV.secondaryContactEmail ?? '');
            setsecondaryContactName(_selectedGV.secondaryContactName ?? '');
            setsecondaryContactPhone(_selectedGV.secondaryContactPhone ?? '');
        }
    };

    const handleInvite = async (UserEmail) => {

        let userResponse = true;
        if (UserEmail !== null && CurrentUserEmail !== null && UserEmail.split("@")[1].toLowerCase() !== CurrentUserEmail.split("@")[1].toLowerCase()) {
            //userResponse = window.confirm("User is not under same domain as Admin, do you want to proceed?");
            console.log(CurrentUserRoles);
            if( CurrentUserRoles !== 3 ){
                alert('ERROR: User is not under the same domain ' + UserEmail.split("@")[1] + ' as your account. This is not allowed in the Engineering Vendor Portal. If you confirm this is the correct email address to use, please contact Roster PA Admin for this new user');
                return;
            }
        }

        if (userResponse) {
            // const emailExists = users.some(u => u.vendorEmail === UserEmail && UserId !== u.UserId);
            // if (emailExists) {
            //     alert(`The entered email address ${UserEmail} already exists.`);
            //     return;
            // }

            if (UserEmail && UserEmail.toLowerCase().includes('panynj.gov')) {
                alert("User is under PANYNJ domain.");
                return;
            }

            try {
                //const accessToken = await loginAndGetToken();
                //const accessToken = getAccessToken();
                const accesstoken = AccessToken;

                const response = await fetch(variables.API_URL + 'invite/invite', {
                    method: "POST",
                    credentials: "include" ,
                    headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: UserEmail,
                        redirectUrl: "https://engvendor.panynj.gov",
                    }),
                });

                if (response.ok) {
                    alert("Invitation sent successfully!");
                } else {
                    const apiError = await response.json();
                    console.log(apiError.message); // "Failed to send invitation"
                    console.log(apiError.error);   // ex.Message
                    alert(apiError.message + ': ' + apiError.error);
                }
            } catch (err) {
                alert(`Error: ${err.message}`);
                console.log(`Error: ${err.message}`);
            }
        }
    };

    const submitUser = (e) => {
        //if (!isTokenExpired(AccessToken)) {
        {
            // e.preventDefault();
            const isNewUser = UserId === 0;

            if (!regex1.test(UserEmail)) {
                alert('Please enter valid Email.');
                return;
            }
            if (!regex2.test(FullName)) {
                alert('Please enter valid Full Name.');
                return;
            }
            if (!regex2.test(UserTitle)) {
                alert('Please enter valid Title.');
                return;
            }

            const emailExists = users.some(u => u.vendorEmail === UserEmail && UserId !== u.UserId);
            var globalVendorID = selectedOption.value;
            const emailExistsInVendor = UserRoles.some(ur => ur.UserId === UserId && ur.GlobalVendorId === globalVendorID);
            if (emailExists && emailExistsInVendor && isNewUser) {
                alert(`The entered email address ${UserEmail} already exists.`);
                return;
            }
            if (!UserEmail || !FullName || !UserTitle || selectedRoles.length === 0) {
                alert(`Please enter all required fields.`);
                return;
            }
            if (UserEmail !== null && CurrentUserEmail !== null && UserEmail.split("@")[1].toLowerCase() !== CurrentUserEmail.split("@")[1].toLowerCase() && !CurrentUserEmail.toLowerCase().includes("panynj.gov")) {
                //alert('WARNING: User is not under the same domain ' + UserEmail.split("@")[1] + ' as your account');
                 alert('ERROR: User is not under the same domain ' + UserEmail.split("@")[1] + ' as your account. This is not allowed in the Engineering Vendor Portal. If you confirm this is the correct email address to use, please contact Roster PA Admin for this new user');
                return;
                // * Task 5888 below. Julia after discussion with Yan asked to roll it back to error message.

                // if (window.confirm('WARNING: User is not under the same domain ' + UserEmail.split("@")[1] + ' as your account. Do you want to proceed?')) {
                // }
                // else {
                //     return;
                // }
            }
            const bodyUser = {
                UserEmail: UserEmail.toLowerCase(),
                FullName: FullName,
                Title: UserTitle,
                RegistrationStatus: RegistrationStatus,
                IsActive: !IsActive || IsActive === "false" ? 0 : 1,
                RoleIds: selectedRoles,
            };
            if (!isNewUser) bodyUser['UserId'] = UserId;
            console.log("submitUser UserId: ", UserId);
            console.log("submitUser selectedOption: ", selectedOption);

            
            const payload = {
                bodyUser,
                vendorName,
                globalVendorID,
            };

            fetch(variables.API_URL + 'user', {
                method: isNewUser ? 'POST' : 'PUT',
                credentials: "include", 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
                .then(res => res.json())
                .then((result) => {
                    alert(result);
                    refreshList();
                    closeModal();
                }, (error) => {
                    alert('Failed');
                })
        }
        // else {
        //     navigate('/signin');
        // }
    };

    const deActivateClick = (id) => {
        if (window.confirm('User will be deactivated. Press OK to continue the change.')) {
            //const accesstoken = AccessToken;
            fetch(variables.API_URL + 'user/Deactivate?userId='+id+'&vendorId=' + selectedOption.value, {
                method: 'DELETE',
                credentials: "include", 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
                .then(res => res.json())
                .then((result) => {
                    alert(result);
                    refreshList();
                }, (error) => {
                    alert('Failed');
                })
        }
    };

    const handleRoleChange = (e) => {
        const options = e.target.options;
        const value = [];
        for (let i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(Number(options[i].value));
            }
        }
        setSelectedRoles(value);
    };

    const handleFilterChange = (event) => {
        setFilterQuery(event.target.value);
    };

    const addNewUser = () => {
        setIsEditing(false);
        setShowModal(true);
        setModalTitle("Add User");
        setSelectedUser("");
        setUserTitle("");
        setUserEmail("");
        setFullName("");
        setUserId(0);
        setIsActive(true);
        setSelectedRoles([]);
        setShowInviteButton(false);
    };

    const openModal = (user) => {

        // console.log("selectedOption: ", selectedOption);
        const _selectedRoles = UserRoles.filter(item => item.userId === user.userId && item.globalVendorID === selectedOption.value ).map(item => item.roleId);

        setIsEditing(true);
        setShowModal(true);
        setModalTitle("Edit User");
        setSelectedUser(user);
        setUserTitle(user.title);
        setUserEmail(user.vendorEmail);
        setSelectedRoles(_selectedRoles);
        setFullName(user.fullName);
        setRegistrationStatus(user.registrationStatus);
        setUserId(user.userId);
        setIsActive(user.isActive);
        setShowInviteButton(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setIsEditing(false);
        setSelectedUser("");
    };


    let _User = users;

    if (CurrentUserRoles === 2) {
        _User = users.filter((user) => {
            return (
                // !user.vendorEmail.toLowerCase().includes("panynj.gov") &&
                // Number(user.globalVendorID) === Number(GlobalVendorId)
                !user.vendorEmail.toLowerCase().includes("panynj.gov")
            );
        });
    }

    if (CurrentUserRoles === 2 && CurrentUserEmail.toLowerCase().includes("panynj.gov")) {
        _User = users.filter((user) => {
            return (
                Number(user.globalVendorID) === Number(GlobalVendorId)
            );
        });
    }

    const filteredUsers = _User.filter((user) => {
        if(selectedOption != null ) {
            return (
                
                user.globalVendorID === selectedOption?.value && (

                user.fullName.toLowerCase().includes(filterQuery.toLowerCase()) ||
                user.title?.toLowerCase().includes(filterQuery.toLowerCase()) ||
                user.vendorEmail.toLowerCase().includes(filterQuery.toLowerCase())
                )
            );
        }
    });

    var dummyData = {
        RolesOption: []
    };

    if (CurrentUserRoles !== null && Number(CurrentUserRoles) === 3 && CurrentUserEmail && CurrentUserEmail.toLowerCase().includes("panynj.gov") && selectedUser && selectedUser.vendorEmail.toLowerCase().includes("panynj.gov")) {
        dummyData = {
            RolesOption: [
                {
                    roleId: 3,
                    description: 'PA Admin',
                },
                {
                    roleId: 2,
                    description: 'Firm Admin',
                },
                {
                    roleId: 1,
                    description: 'Agreement Manager',
                },
            ]
        }
    }
    else {
        dummyData = {
            RolesOption: [
                {
                    roleId: 2,
                    description: 'Firm Admin',
                },
                {
                    roleId: 1,
                    description: 'Agreement Manager',
                },
            ]
        }
    }
    const options = globalVendors && globalVendors.map(vend => ({
        value: vend.globalVendorID,
        label: vend.vendorName + " ( EIN: " + (vend.eiN_Encrypted==null?"N/A":vend.eiN_Encrypted) +")"
    }));

    return (
        <div className='m-4 flex flex-col justify-start w-full rounded'>
            <h5 className="text-xl mb-5 pl-4">Vendor Users</h5>
            {
                CurrentUserRoles !== null && (Number(CurrentUserRoles) === 3 || (Number(CurrentUserRoles) === 2 && globalVendors.length > 0)) &&
                <div className='p-3 w-2/2 bg-slate-100 rounded'>
                    <table style={{ width: "100%"}}>
                        <tr>
                            
                            <td style={{ verticalAlign: "bottom", width: "70%" , textalign: "left"}}>
                                <h6 >Vendor:</h6>
                                <Select
                                    options={options}
                                    value={selectedOption}
                                    onChange={handleSelectChange}
                                    placeholder="Search and select a vendor"
                                />
                            </td>
                            <td style={{ verticalAlign: "bottom", width: "15%" , textAlign: "left", paddingLeft: "20px"}}>
                                <h6 >Filter:</h6>
                                <input type="text" placeholder="Filter by Name, Title, Email" value={filterQuery} onChange={handleFilterChange}
                                className="border border-gray-300" style={{ width: "240px", height: "35px" }} />
                            </td>
                            <td style={{ verticalAlign: "bottom", width: "15%" , textalign: "right"}}>
                                <button type="button"
                                className="bg-blue-500 text-white p-2 rounded float-end"  style={{ width: "180px", height: "35px" }} 
                                onClick={addNewUser}>
                                Add New User
                                </button>
                            </td>
                        </tr>
                    </table>
                    
                    
                </div>
            }

            <table id='AgreementsSearchResults' className='table table-auto border rounded p-5 overflow-y-scroll max-h-96'>
                <thead className="border rounded p-5 text-left">
                    <tr className='p-4 bg-blue-200'>
                        <th className='p-4'>Full Name</th>
                        <th className='p-4'>Title</th>
                        <th className='p-4'>Vendor Name</th>
                        <th className='p-4'>Vendor Email</th>
                        <th className='p-4'>Roles</th>
                        <th className='p-4'>Active</th>
                        <th className="p-4">Edit</th>
                        <th className="p-4">Deactivate</th>                       
                    </tr>
                </thead>
                <tbody>
                    {
                        filteredUsers.filter(item => item.isActive === true).map(item => {
                            const IsPAAdmin = UserRoles.filter(i => i.userId === item.userId && i.roleId === 3).length > 0;
                            console.log("filteredUsers: ", filteredUsers);
                            return (
                                <tr key={`${item.userId}-${item.globalVendorID}`} className="odd:bg-gray-100">
                                    <td className='p-4'>{item.fullName}</td>
                                    <td className='p-4'>{item.title}</td>
                                    <td className='p-4'>{item.vendorName}</td>
                                    <td className='p-4'>{item.vendorEmail}</td>
                                    <td>
                                        {
                                            UserRoles.filter(i => i.userId === item.userId && i.globalVendorID === item.globalVendorID).map(i => i.description).join(', ')
                                        }
                                    </td>
                                    <td className='p-4'>{item.isActive ? 'Yes' : 'No'}</td>
                                    <td className='p-4'>
                                        <button
                                            onClick={() => openModal(item)}
                                            className="underline font-bold text-blue-600"
                                            disabled={IsPAAdmin}
                                            hidden={IsPAAdmin}
                                        >
                                            {Icons.EditIcon({ className: "w-4 cursor-pointer" })}
                                        </button>
                                    </td>
                                    <td className='p-4'>
                                        <button
                                            onClick={() => deActivateClick(item.userId)}
                                            className="underline font-bold text-blue-600"
                                            disabled={IsPAAdmin}
                                            hidden={IsPAAdmin}
                                        >
                                            {Icons.DeleteIcon({ className: "w-4 cursor-pointer" })}
                                        </button>
                                    </td>                                   
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
            {
                showModal && ((selectedUser && modalTitle === "Edit User") || modalTitle === "Add User") && (
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10">
                        <div className="bg-white p-6 rounded shadow-lg max-w-md w-full">
                            <h2 className="text-xl font-semibold mb-4">{modalTitle}</h2>
                            <form>
                                {
                                    ShowWarning ?
                                        <div className="warning">
                                            <Alert key='warning' variant='warning'>
                                                {Warning}
                                            </Alert>
                                        </div>
                                        : null
                                }
                                <div className="mb-4">
                                    <label className="block">Vendor Name</label>
                                    <input
                                        type="vendorName"
                                        name="UserVendorName"
                                        value={vendorName}
                                        className="p-2 border border-gray-300 w-full"
                                        disabled="true"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block">EIN</label>
                                    <input
                                        type="EIN"
                                        name="UserEIN"
                                        value={eiN_Encrypted}
                                        className="p-2 border border-gray-300 w-full"
                                        disabled="true"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block">Email</label>
                                    <input
                                        type="email"
                                        name="UserEmail"
                                        value={UserEmail.toLowerCase()}
                                        onChange={handleChange}
                                        className="p-2 border border-gray-300 w-full"
                                        disabled={modalTitle === "Edit User"}
                                    />
                                    {
                                        showInviteButton
                                            ?
                                            <button type="button"
                                                className="bg-sky-500/100 text-white p-1 rounded float-end"
                                                onClick={() => handleInvite(UserEmail)}>
                                                Invite
                                            </button>
                                            :
                                            <button type="button"
                                                className="bg-sky-500/100 text-white p-1 rounded float-end  ms-8"
                                                onClick={() => verifyUser(UserEmail)}
                                                hidden={modalTitle === "Edit User"}>
                                                Verify User
                                            </button>
                                    }
                                </div>
                                <div className="mb-4">
                                    <label className="block">Full Name</label>
                                    <input
                                        type="text"
                                        name="FullName"
                                        value={FullName}
                                        onChange={handleChange}
                                        className="p-2 border border-gray-300 w-full"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block">Title</label>
                                    <input
                                        type="text"
                                        name="UserTitle"
                                        value={UserTitle}
                                        onChange={handleChange}
                                        className="p-2 border border-gray-300 w-full"
                                    />
                                </div>
                                <div className="input-group mb-4">
                                    <span className="input-group-text">Active</span>
                                    <Input
                                        type="select"
                                        className="form-select p-2 border border-gray-300 w-full"
                                        onChange={handleChange}
                                        name="IsActive"
                                        id="IsActive"
                                        value={IsActive}>
                                        <option value="false">No</option>
                                        <option value="true">Yes</option>
                                    </Input>
                                </div>
                                <div className="input-group mb-4">
                                    <span className="input-group-text">Roles</span>
                                    <select
                                        className="form-select p-2 border border-gray-300 w-full"
                                        title="Roles"
                                        multiple
                                        value={selectedRoles}
                                        onChange={handleRoleChange}>
                                        {dummyData.RolesOption.map((ro, index) =>
                                            (<option key={index} value={ro.roleId}>{ro.description}</option>)
                                        )}
                                    </select>
                                </div>
                                {/* <div className="input-group mb-4">
                                    <span className="input-group-text">Roles</span>                                 
                                    <input
                                        type="text"
                                        className="form-control mb-2 p-2 border border-gray-300 w-full"
                                        placeholder="Search roles..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <select
                                        className="form-select p-2 border border-gray-300 w-full"
                                        title="Role"
                                        multiple
                                        value={selectedRoles}
                                        onChange={handleRoleChange}>
                                        {filteredVendors.map((ro, index) => (
                                            <option key={index} value={ro.globalVendorID}>
                                                {ro.vendorName}
                                            </option>
                                        ))}
                                    </select>
                                </div> */}
                                <div className="input-group mb-3">
                                    * Press CTRL on the keyboard to select multiple roles.
                                </div>
                                <div className="flex justify-between">
                                    <button type="button" onClick={() => closeModal()} className="bg-gray-300 p-2 rounded">Cancel</button>
                                    <button type="button" onClick={() => submitUser()} className="bg-blue-500 text-white p-2 rounded">
                                        Save Changes
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
        </div>
    );
};

export default User;